import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cancelamento-evasao`

    return {
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        cancel(id, params) {
            return repository.patch(`${baseUrl}/${id}/cancel`, params)
        }
    }
}